import { render, staticRenderFns } from "./Evidence.vue?vue&type=template&id=cd789768&scoped=true"
import script from "./Evidence.vue?vue&type=script&lang=js"
export * from "./Evidence.vue?vue&type=script&lang=js"
import style0 from "./Evidence.vue?vue&type=style&index=0&id=cd789768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd789768",
  null
  
)

export default component.exports